<template>
    <div>
        <el-dialog :visible.sync="forgetDialog" width="320px" :close-on-click-modal="false" @close="handleCloseForget">
            <div
                class="ms-title"
                style="font-size: 14px; color: #666; margin-bottom: 24px; cursor: pointer; display: flex; justify-content: center"
            >
                <!-- 个人忘记密码  和  企业忘记密码 两个标题切换 -->
                <span style="margin-left: 20px; min-width: 100px; text-align: center; border-bottom: #fff solid 1px; padding-bottom: 9px">{{
                    title == 1 ? '个人忘记密码 ' : '企业忘记密码'
                }}</span>
            </div>
            <!-- 个人忘记密码确认身份证号弹窗 -->
            <div v-if="title == 1">
                <el-form :model="cardForm" :rules="rules" ref="cardForm" label-width="0px" class="ms-content">
                    <el-form-item prop="id_card">
                        <el-input v-model="cardForm.id_card" placeholder="请输入注册时的身份证号">
                            <el-button slot="prepend" style="width: 5px; height: 5px" class="headImg perImg"></el-button>
                        </el-input>
                    </el-form-item>
                    <div class="login-btn">
                        <el-button type="primary" @click="confirm(1)" style="width:100%;">确定</el-button>
                    </div>
                </el-form>
            </div>
            <!-- 企业忘记密码确认统一社会信用代码 -->
            <div v-else>
                <el-form :model="cardForm" :rules="rules" ref="cardForm" label-width="0px" class="ms-content">
                    <el-form-item prop="id_card">
                        <el-input v-model="cardForm.id_card" placeholder="请输入注册时的统一社会信用代码">
                            <el-button slot="prepend" style="width: 5px; height: 5px" class="headImg cardImg"></el-button>
                        </el-input>
                    </el-form-item>
                    <div class="login-btn">
                        <el-button type="primary" @click="confirm(2)" style="width:100%;">确定</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import user from '@/api/user';
// import confirmInfo from '@/api/user';
export default {
    data() {
        return {
            forgetStyle: 1,
            cardForm: {
                id_card: ''
            },
            rules: {
                id_card: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
                newpassword: [
                    { required: true, message: '请设置新登录密码', trigger: 'blur' },
                    {
                        min: 6,
                        max: 20,
                        message: '密码长度在6-20位之间',
                        trigger: ['blur', 'change']
                    }
                ],
                // newpassword2: [
                //     { required: true, message: '请确认新登录密码', trigger: 'blur' },
                //     { validator: validatePass2, trigger: ['blur', 'change'] }
                // ],
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1\d{10}$/, message: '手机号格式不对', trigger: 'blur' }
                ],
                captcha: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }]
            }
        };
    },
    props: {
        forgetDialog: { type: Boolean, default: false },
        registerDialog: { type: Boolean, default: false },
        title: { type: Number, default: 1 },
        personalMobile: { type: String, default: ' ' },
        companyMobile: { type: String, default: ' ' }
    },
    methods: {
        handleCloseForget() {
            // 关闭弹窗
            this.cardForm = {}; //清空表单
            // this.forgetForm = {}; //清空表单
            // if (this.title) {
            //     this.$refs.cardForm.resetFields(); //清空验证
            // } else {
            //     this.$refs.forgetForm.resetFields(); //清空验证
            // }
            //通知父组件更改 忘记密码框的状态
            this.$emit('update:forgetDialog', false);
        },
        confirm(val) {
            console.log(val);

            this.$refs.cardForm.validate(valid => {
                if (valid) {
                    user.confirmInfo({ userName: this.cardForm.id_card })
                        .then(res => {
                            console.log('saiudhnanf');
                            if (val == 1) {
                                // this.forgetStyle = 1;
                                this.$message.success('身份证验证通过');
                                //let idcard = res.data;
                                //setCookies('idcard', res.data);
                                this.$emit('regSwitch', { idcard: res.data.cardid });
                                this.$emit('update:personalMobile', res.data.mobile);
                                // this.forgetDialog = false;
                            } else {
                                // this.forgetStyle = 2;
                                this.$message.success('统一社会信用代码验证通过');
                                this.$emit('companySwitch', { companycode: res.data.cardid });
                                this.$emit('update:companyMobile', res.data.mobile);
                                // this.forgetDialog = false;
                                // this.$emit('regSwitch', { idcard: res.data });
                            }
                        })
                        .catch(error => {
                            this.$message.error(error.msg);
                        });
                }
            });
        }
    }
};
</script>

<style lang="less">
.switch {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 34px;
    .letter {
        font-size: 14px;
        font-weight: 400;
        cursor: pointer;
        transition: all 0.2s;
        &:hover {
            color: #1890ff;
        }
    }
    .line {
        background-color: #ccc;
        width: 1px;
        height: 14px;
        margin: 0 19px;
    }
}
.login-btn {
    /deep/.el-button--primary {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
        width: 100% !important;
    }
    /deep/.el-button--small,
    .el-button--small.is-round {
        padding: 9px 15px;
        width: 100% !important;
    }
}
/deep/.el-button--primary {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    width: 100% !important;
}
/deep/.el-button--small,
.el-button--small.is-round {
    padding: 9px 15px;
    width: 100% !important;
}
.perImg {
    background-image: url('~@/assets/img/personal.png');
}
.headImg {
    background-image: url('~@/assets/img/img.png');
    width: 5px;
    height: 5px;
    background-repeat: no-repeat;
    position: absolute;
    left: 33px;
    top: 17px;
}
</style>
